import { apiFetch } from './apiClient.js';

/**
 * #163 — Cliente UI para WhatsApp Flows (Meta) CRUD.
 * Backend: services/tenant-mgmt/src/handlers/providerFlows.ts.
 */

export type WaFlowStatus = 'DRAFT' | 'PUBLISHED' | 'DEPRECATED' | 'BLOCKED' | 'THROTTLED';

export interface WaFlow {
  id: string;
  name: string;
  status: WaFlowStatus;
  categories: string[];
  validation_errors?: Array<Record<string, unknown>>;
}

interface ListResp { items: WaFlow[] }

export async function listWaFlows(tenantId: string, connectorId: string): Promise<WaFlow[]> {
  const res = await apiFetch<ListResp>(base(tenantId, connectorId));
  return res.items ?? [];
}

export async function createWaFlow(
  tenantId: string,
  connectorId: string,
  body: { name: string; categories: string[]; flowJson?: string },
): Promise<{ id: string }> {
  return apiFetch<{ id: string }>(base(tenantId, connectorId), { method: 'POST', body });
}

export async function getWaFlowJson(
  tenantId: string,
  connectorId: string,
  flowId: string,
): Promise<string> {
  // El backend devuelve el flow_json crudo (object). Lo serializamos para edición.
  const obj = await apiFetch<unknown>(
    `${base(tenantId, connectorId)}/${encodeURIComponent(flowId)}/json`,
  );
  return typeof obj === 'string' ? obj : JSON.stringify(obj, null, 2);
}

export async function updateWaFlowJson(
  tenantId: string,
  connectorId: string,
  flowId: string,
  flowJson: string,
): Promise<void> {
  await apiFetch<void>(
    `${base(tenantId, connectorId)}/${encodeURIComponent(flowId)}/json`,
    { method: 'PUT', body: { flowJson } },
  );
}

export async function publishWaFlow(
  tenantId: string,
  connectorId: string,
  flowId: string,
): Promise<void> {
  await apiFetch<void>(
    `${base(tenantId, connectorId)}/${encodeURIComponent(flowId)}/publish`,
    { method: 'POST' },
  );
}

export async function deprecateWaFlow(
  tenantId: string,
  connectorId: string,
  flowId: string,
): Promise<void> {
  await apiFetch<void>(
    `${base(tenantId, connectorId)}/${encodeURIComponent(flowId)}/deprecate`,
    { method: 'POST' },
  );
}

export async function deleteWaFlow(
  tenantId: string,
  connectorId: string,
  flowId: string,
): Promise<void> {
  await apiFetch<void>(
    `${base(tenantId, connectorId)}/${encodeURIComponent(flowId)}`,
    { method: 'DELETE' },
  );
}

function base(tenantId: string, connectorId: string): string {
  return `/v1/tenants/${encodeURIComponent(tenantId)}/connectors/${encodeURIComponent(connectorId)}/wa-flows`;
}
